exports.f = {}.propertyIsEnumerable;


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/core-js/modules/_object-pie.js
// module id = 225
// module chunks = 1